import { CSSResultArray } from 'lit';
import style from './mc-number-stepper.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/number-stepper/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [tokens, style];
